/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-11-23 16:41:51
 * @LastEditors: caiqin.xie
 * @message: 服务支持主页-服务中心
 */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Input, Select, Carousel, Form, Button } from '@arco-design/web-react';
import Empty from '../../../shop/components/Empty'
import CarouselShopItem from "../../../shop/components/CarouselShopItem";
import styles from "../../index.module.scss";
import request from '@/common/request'
import { DOMAIN_API} from '@/common/const'
import { IShop } from "@/common/types";

interface IProps {
  ctry: string;
  words: Record<string, string>;
  shop: IShop; // 门店信息
  areaList: ISelectList[] // 区域列表
  getList: (query:any)=>void // 搜索门店
}
interface ISelectList {
  name: string,
  id: string
}
const ServiceCenter = (props: IProps) => {
  const { ctry, words, shop, areaList, getList } = props
  const [countryList, setCountryList] = useState<ISelectList[]>([]) // 国家列表
  const [areaId, setAreaId] = useState<string>() // 区域ID
  const [countryId, setCountryId] = useState<string>() // 国家ID
  const [keyword, setKeyword] = useState<string>('') // 关键词
  const [initShop] = useState(props.shop)
  console.log('initShop', initShop)

  // 获取国家列表
  const getCountryList = (areaId: string) => {
    request.get(`${DOMAIN_API}/o/official/area/getCountryList`, { params: { areaId } })
      .then(res => {
        const { data } = res.data
        setCountryList(data)
      })
      .catch(err => {
        console.log(err)
      })
  }
  return (
    <>
      {initShop && (
        <section className={`${styles["support-store"]} ${styles["support-section"]}`}>
          <h2>
            {words.support_home_shop_title}
            {/* Service Center */}
          </h2>
          <Form autoComplete='off' layout='inline' className={styles["store-search-wrap"]} >
            <div className={styles["store-search-item"]}>
              <span className={styles["store-search-label"]}>{words?.shop_search_areas}</span>
              {/* Areas */}
              <Select
                size='large'
                placeholder={words?.shop_search_select_placeholder}
                value={areaId}
                onChange={(e:string) => { setCountryId(undefined); getCountryList(e); setAreaId(e) }}
                allowClear
              >
                {areaList.map((option: ISelectList) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.name}
                  </Select.Option>
                ))}
              </Select>
            </div>
            <div className={styles["store-search-item"]}>
              <span className={styles["store-search-label"]}>{words?.shop_search_country}</span>
              {/* Country */}
              <Select
                size='large'
                placeholder={words?.shop_search_select_placeholder}
                allowClear
                value={countryId}
                onChange={(e:string) => { setCountryId(e) }}
              >
                {countryList.map((option: ISelectList) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.name}
                  </Select.Option>
                ))}
              </Select>
            </div>
            <div className={styles["store-search-item"]}>
              <span className={styles["store-search-label"]}>{words?.shop_search_store}</span>
              {/* Store */}
              <Input size='large' placeholder={words?.shop_search_input_placeholder} onChange={(value:string) => setKeyword(value)} />
            </div>
            <Button className={styles["store-search-btn"]} onClick={() => getList({ areaId, countryId, keyword })}>{words?.common_search}</Button>
            {/* Search */}
          </Form>
          {shop?.id ? (<><div className={styles["store-list"]}>
            <CarouselShopItem carousel={true} shop={shop} />
          </div>
            <p className={styles["more-store"]}>
              <a href={`/${ctry}/shop/service-shop?areaId=${areaId || ''}&countryId=${countryId || ''}&keyword=${keyword || ''}`}>
                <span className={styles["learn-more-purple"]}>
                  {words.common_learn_more}
                  {/* Learn More */}
                </span>
              </a>
            </p></>) :<Empty words={words} />}
        </section>
      )}
    </>
    
  )
}
export default ServiceCenter
